import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { GET_USERS } from '../graphql/queries';
import { User } from '../types';
import { UserContext } from './useUserContext';

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const token = localStorage.getItem('loginToken');
  const { data, loading, error } = useQuery<{ users: User[] }>(GET_USERS, {
    skip: !token || token.length === 0,
  });
  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    if (data && data.users) {
      setUsers(data.users);
    }
  }, [data]);

  const getUserColor = (name: string) => {
    const user = users.find(u => u.name === name);
    return user?.color || '#ffffff';
  };

  return (
    <UserContext.Provider value={{ users, loading, error, getUserColor }}>
      {children}
    </UserContext.Provider>
  );
};
